'use client'
import { useTranslate } from '../../hooks'
import { Col, NumberUnit, Row, Typography } from '@repo/ui/components'
import type { CSSVariableColor } from '@repo/ui/types/colors'
import { OrderbookTradesEmpty } from './orderbook.trades-empty'
import { ToDateTime } from '../../components'

const mockTrades = [
  { price: 69000, amount: 100, time: '2025-07-14T09:39:21.856Z', type: 'sell' },
  { price: 71500, amount: 100, time: '2025-07-14T09:39:21.856Z', type: 'buy' },
  { price: 71000, amount: 1500, time: '2025-07-14T09:39:21.856Z', type: 'buy' },
  { price: 72000, amount: 300, time: '2025-07-14T09:39:21.856Z', type: 'sell' },
  { price: 70500, amount: 300, time: '2025-07-14T09:39:21.856Z', type: 'buy' },
  {
    price: 69900,
    amount: 100000,
    time: '2025-07-14T09:39:21.856Z',
    type: 'buy',
  },
]

export function OrderbookTrades() {
  const { t } = useTranslate()
  if (!mockTrades.length) return <OrderbookTradesEmpty />

  return (
    <Col className='mt-md'>
      <Row className='mb-md pb-xs'>
        <Col>
          <Typography size='xs' color='text-neutral-surface-80'>
            {t('orderbook_price')}
          </Typography>
        </Col>
        <Col>
          <Typography size='xs' color='text-neutral-surface-80'>
            {t('orderbook_amount')}
          </Typography>
        </Col>
        <Col>
          <Typography
            size='xs'
            color='text-neutral-surface-80'
            className='flex justify-end'
          >
            {t('orderbook_time')}
          </Typography>
        </Col>
      </Row>
      {mockTrades.map((trade, idx) => {
        const isSell = trade.type === 'sell'
        const color = isSell
          ? {
              text: 'text-negative-surface-100',
            }
          : {
              text: 'text-positive-surface-100',
            }
        return (
          <Row key={idx} className={`mb-xs py-xs px-xs rounded-md `}>
            <Col>
              <NumberUnit
                numberColor={color.text as CSSVariableColor}
                isBold={false}
                value={trade.price}
                numberSize='sm'
              />
            </Col>
            <Col>
              <NumberUnit
                numberColor={color.text as CSSVariableColor}
                isBold={false}
                value={trade.amount}
                numberSize='sm'
              />
            </Col>
            <Col>
              <Typography
                variant='bdi'
                size='xs'
                className='whitespace-nowrap flex justify-end'
                color='text-neutral-surface-80'
              >
                {trade.time ? (
                  <ToDateTime
                    date={new Date(trade.time ?? '')}
                    showSeconds={true}
                  />
                ) : (
                  '-'
                )}
              </Typography>
            </Col>
          </Row>
        )
      })}
    </Col>
  )
}
